const STATUSES: Statuses = {
	UPDATED: {
		type: "edited",
		title: "Gewijzigd",
		color: "#E5B900",
	},
	DELETED: {
		type: "cancelled",
		title: "Geannuleerd",
		color: "#BC0000",
	},
	ACTION: {
		type: "action",
		title: "Actie vereist",
		color: "#DD0000",
	},
	NEW: {
		type: "new",
		title: "",
		color: "#969F73",
	},
};

type Statuses = {
	[key: string]: Status;
};

type Status = {
	type: string;
	title: string;
	color: string;
};
export default STATUSES;
